import type { SVGProps } from "react";
export interface Parcel01StarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Parcel01StarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Parcel01StarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 2a1.125 1.125 0 0 1 2.25 0v4.875h8.263l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H2.612a1.125 1.125 0 0 1 0-2.25h8.263z"
      />
      <path
        fill={color}
        d="M20.375 8.812c0-.25-.05-.496-.145-.724l-.11-.221-2.223-3.812a1.88 1.88 0 0 0-1.62-.93H7.724c-.667 0-1.284.354-1.62.93L3.88 7.867a1.9 1.9 0 0 0-.255.945V19c0 1.035.84 1.875 1.875 1.875h13c1.036 0 1.875-.84 1.875-1.875zm-9.496 1.642a1.376 1.376 0 0 1 2.243 0l.105.177.836 1.667 1.884.27c1.104.157 1.601 1.53.756 2.34l-1.35 1.292.317 1.823c.19 1.086-.868 1.848-1.798 1.527l-.185-.079-1.688-.871-1.687.871c-.967.5-2.185-.29-1.983-1.448l.317-1.823-1.349-1.292c-.845-.81-.347-2.183.756-2.34l1.881-.27.84-1.667zm.803 3.38c-.166.33-.482.558-.847.61l-.672.095.473.453c.27.259.395.635.33 1.005l-.116.663.634-.326.124-.056c.295-.11.625-.09.909.056l.63.326-.113-.663a1.12 1.12 0 0 1 .33-1.005l.471-.453-.67-.095a1.13 1.13 0 0 1-.846-.61l-.32-.634-.317.635ZM22.625 19a4.125 4.125 0 0 1-4.125 4.125h-13A4.125 4.125 0 0 1 1.375 19V8.812c0-.73.194-1.448.563-2.08l2.222-3.81A4.13 4.13 0 0 1 7.724.874h8.553c1.467 0 2.823.78 3.562 2.046l2.224 3.812.13.24c.284.57.432 1.2.432 1.839z"
      />
    </svg>
  );
}
